import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6071235b")

_pushScopeId("data-v-6071235b")
const _hoisted_1 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_2 = {
  class: "flex-grow-1 py-4 px-5",
  style: {"background":"{{ background }}"}
}
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_4 = { class: "w-75" }
const _hoisted_5 = { class: "widget-content-area" }
const _hoisted_6 = { class: "text-muted fs-7" }
const _hoisted_7 = { class: "icon-wrapper w-25 text-end" }
const _hoisted_8 = { class: "icon-holder mb-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card order-widget customer-order-widget"]
  }, [
    (_ctx.loaderEnabled)
      ? (_openBlock(), _createBlock(_component_InnerLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", {
                class: [`text-${_ctx.chartColor}`, "fw-bolder main-content lh-1.4"]
              }, _toDisplayString(_ctx.getKey), 3),
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.title)), 1)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("img", {
                src: _ctx.icon,
                alt: _ctx.title
              }, null, 8, ["src", "alt"])
            ])
          ])
        ])
      ])
    ])
  ], 2))
})